/**
 * @typedef modalDescriptors
 * @type {Array<{
 *   isActive: (() => boolean) | string,
 *   id: any
 * }>}
 */
/**
 * Used by components that use modals.
 * The component with this mixin must define a property named `modalDescriptors` of type {modalDescriptors}. It must not
 * be changed after the component has been created.
 */
export default {
  methods: {
    registerOrUnregisterModal(newVal, id) {
      this.$store.commit(`ui/${newVal ? '' : 'un'}registerBodyScrollBlocker`, id);
      this.$store.commit(`ui/${newVal ? '' : 'un'}registerModalMasker`, id);
    },
  },
  created() {
    for (const modalDescriptor of this.modalDescriptors) {
      this.$watch(
        modalDescriptor.isActive,
        n => this.registerOrUnregisterModal(n, modalDescriptor.id),
        { immediate: true },
      );
    }
  },
  beforeDestroy() {
    for (const modalDescriptor of this.modalDescriptors) {
      this.registerOrUnregisterModal(false, modalDescriptor.id);
    }
  },
}
